import filter from 'lodash-es/filter';
import map from 'lodash-es/map';
import { makeAutoObservable, observable } from 'mobx';
import { FileData, FileModel } from 'entities/file/model/fileModel';
import { TableData, TableModel } from 'entities/table/model/tableModel';
import { ContentFileItem, ContentTableItem } from 'entities/types';

export class ContentHelper {
  private _fetchFiles: () => Promise<FileData[]>;
  private _fetchTables: () => Promise<TableData[]>;

  constructor({
    fetchFiles,
    fetchTables,
  }: {
    fetchFiles: () => Promise<FileData[]>;
    fetchTables: () => Promise<TableData[]>;
  }) {
    this._fetchFiles = fetchFiles;
    this._fetchTables = fetchTables;
    makeAutoObservable(this);
  }

  public isPending = false;

  public get isLoadend() {
    return Boolean(!this.isPending && this.files && this.tables);
  }

  public files: FileModel[] | null = null;
  public tables: TableModel[] | null = null;
  public content: (ContentFileItem | ContentTableItem)[] = [];

  public async fetchContent() {
    this.isPending = true;
    try {
      const [files, tables] = await Promise.all([
        this._fetchFiles(),
        this._fetchTables(),
      ]);

      this.files = map(files, (fileData) => new FileModel(fileData));
      this.tables = map(tables, (tableData) => new TableModel(tableData));
      this.transformContent();
    } catch (e) {
      console.error(e);
    }
    this.isPending = false;
  }

  public localDeleteFile(id: string) {
    if (this.files) {
      this.files = filter(this.files, (file) => file.id !== id);
      this.transformContent();
    }
  }

  public localDeleteTable(id: string) {
    if (this.tables) {
      this.tables = filter(this.tables, (tables) => tables.id !== id);
      this.transformContent();
    }
  }

  private transformContent() {
    const contentFiles =
      map(this.files, (file) => ({
        id: file.data!.id,
        type: file.type,
        name: file.data!.name,
        is_favorite: file.data!.is_favorite,
        last_change_date: file.data!.last_change_date,
        username: file.data!.username,
        preview_url: file.data!.rawPreviewUrl || null,
        size: file.data!.size,
        extension: file.data!.type,
        section_id: file.data!.section_id,
        folder_id: file.data!.folder_id,
      })) || [];

    const contentTables =
      map(this.tables, (table) => ({
        id: table.data!.id,
        type: table.type,
        name: table.data!.name,
        is_favorite: table.data!.is_favorite,
        last_change_date: table.data!.last_change_date,
        username: table.data!.username,
        section_id: table.data!.section_id,
        folder_id: table.data!.folder_id,
      })) || [];

    this.content = [...contentFiles, ...contentTables];
  }
}
